import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { DataInfoComponent } from './data-info/data-info.component';
import { DataSourcesControlsComponent } from './data-info/data-sources-info/data-sources-controls/data-sources-controls.component';
import { DataSourcesContentComponent } from './data-info/data-sources-info/data-sources-content/data-sources-content.component';
import { HwwContentComponent } from './data-info/hww-info/contents/hww-content/hww-content.component';
import { InteractiveSchemaComponent } from './data-info/hww-info/interactive-schema/interactive-schema.component';
import { MatListModule } from '@angular/material/list';
import { InfoFaqComponent } from './data-info/info-faq/info-faq.component';
import { DATA_SOURCES_FAQ } from './data-info/data-sources-info/data-sources.faq';
import { HWW_FAQ } from './data-info/hww-info/hww.faq';
import { REUSE_ROUTE_DATA_KEY } from '../custom-route-reuse.strategy';

const routes: Routes = [
  {
    path: '',
    component: DataInfoComponent,
    children: [
      {
        path: '',
        redirectTo: 'data-sources',
        pathMatch: 'full',
      },
      {
        path: 'data-sources',
        // Each tab applies its own title, canonical and FAQ JSON-LD on init; a
        // tab CustomRouteReuseStrategy reattached would keep the other's.
        data: { [REUSE_ROUTE_DATA_KEY]: false },
        children: [
          {
            path: '',
            component: DataSourcesContentComponent,
            outlet: 'contents',
          },
          {
            path: '',
            component: DataSourcesControlsComponent,
            outlet: 'controls',
          },
          {
            path: '',
            component: InfoFaqComponent,
            outlet: 'faq',
            data: { faq: DATA_SOURCES_FAQ },
          },
        ],
      },
      {
        path: 'healthy-wealthy-and-wise',
        data: { [REUSE_ROUTE_DATA_KEY]: false },
        children: [
          { path: '', component: HwwContentComponent, outlet: 'contents' },
          {
            path: '',
            component: InteractiveSchemaComponent,
            outlet: 'controls',
          },
          {
            path: '',
            component: InfoFaqComponent,
            outlet: 'faq',
            data: { faq: HWW_FAQ },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatExpansionModule,
    MatListModule,
    InteractiveSchemaComponent,
    HwwContentComponent,
    DataInfoComponent,
    DataSourcesControlsComponent,
    DataSourcesContentComponent,
  ],
})
export class InfoModule {}
